var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"label":_vm.$t('TransportPage.title'),"prepend-icon":"mdi-car-info","items":_vm.transports,"value":_vm.value,"clearable":_vm.clearable,"disabled":_vm.disabled},on:{"input":_vm.onInput},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('v-icon',{staticClass:"mr-1"},[_vm._v(_vm._s(item.icon))]),_vm._v(" "+_vm._s(item.text)+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }